import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from '../utils/scrollUtils';

/**
 * Hook that automatically scrolls to top when the route changes
 * @param {boolean} smooth - Whether to use smooth scrolling (default: false for instant)
 * @param {Array} dependencies - Additional dependencies to trigger scroll (optional)
 */
export const useScrollToTop = (smooth = false, dependencies = []) => {
  const location = useLocation();

  useEffect(() => {
    scrollToTop(smooth ? 'smooth' : 'auto');
  }, [location.pathname, smooth, ...dependencies]);
};

/**
 * Hook that scrolls to top only on component mount
 * @param {boolean} smooth - Whether to use smooth scrolling
 */
export const useScrollToTopOnMount = (smooth = false) => {
  useEffect(() => {
    scrollToTop(smooth ? 'smooth' : 'auto');
  }, [smooth]);
};

/**
 * Hook that provides scroll-to-top functionality with state
 * @returns {Object} Object with scrollToTop function and isScrolled state
 */
export const useScrollToTopButton = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollToTop = () => {
    scrollToTop('smooth');
  };

  return {
    isScrolled,
    scrollToTop: handleScrollToTop
  };
};

export default useScrollToTop;
